// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3odLY","inner":"Form_inner__3y5-B","range":"Form_range__3e8-d","name":"Form_name__3VGU3","actions":"Form_actions__2Uja8"};